// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"45761b8b","715":"4a0a5367"}[chunkId] + ".chunk.js";
};